import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TStudyPlanStep } from '@datatype/iyagigo/type';

interface IState {
  isMoreProblem: boolean;
  studyPlanStep: TStudyPlanStep;

  // ###################################
  // problemKey -> questionId -> selected choice
  // ###################################
  selectedProblemChoice: Record<string, Record<string, number | null>>;
}

const initialState: IState = {
  isMoreProblem: false,
  studyPlanStep: 'account-choice',
  selectedProblemChoice: {},
};

const cacheSlice = createSlice({
  name: 'cache',
  initialState,
  reducers: {
    initialize: (state) => {
      for (const key in state) {
        state[key] = initialState[key];
      }
    },
    clickIsMoreProblem: (state, action: PayloadAction<boolean>) => {
      state.isMoreProblem = action.payload;
    },
    storeStudyPlanStep: (state, action: PayloadAction<TStudyPlanStep>) => {
      state.studyPlanStep = action.payload;
    },
    // ###################################
    // toeic & jlpt 문제 정답 선택
    // ###################################
    selectProblemAnswer: (
      state,
      action: PayloadAction<{
        problemKey: string;
        questionId: 'A' | 'B' | 'C' | 'D' | 'E';
        selectedChoice: number;
      }>,
    ) => {
      const { problemKey, questionId, selectedChoice } = action.payload;

      if (!state.selectedProblemChoice[problemKey]) {
        state.selectedProblemChoice[problemKey] = {};
      }

      state.selectedProblemChoice[problemKey][questionId] = selectedChoice;
    },
  },
  extraReducers: (builder) => {
    // navigationSlice의 storeIyagigoMainMenu와 storeIyagigoSubMenu 액션을 리스닝
    builder.addMatcher(
      (action) => {
        return action.type === 'navigation/storeIyagigoMainMenu' || action.type === 'navigation/storeIyagigoSubMenu';
      },
      (state) => {
        // cache 초기화
        for (const key in state) {
          state[key] = initialState[key];
        }
      },
    );
  },
});

export const actions = cacheSlice.actions;
export default cacheSlice.reducer;
